module.exports = __webpack_public_path__ + "img/SA_kit.35d23ca0.png";